common.View.create('galaxy::habitats.website.partials.Event', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initTimer();
    },

    initTimer()
    {
        let deadline = new Date( this.element.find('.timer').data('day') ).getTime();

        // Every second
        let x = setInterval(() => {
            // Get current time
            let now = new Date().getTime();

            // Time remaining
            let t = deadline - now;

            // Get amount of days/hours/minutes
            let days = Math.floor(t / (1000 * 60 * 60 * 24)),
                hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60)),
                minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));

            // Add 0 before items
            hours  = (hours < 10 ? '0' : '')  + hours;
            minutes = (minutes < 10 ? '0' : '')  + minutes;

            // Set amounts on elements
            this.element.find('.timer')
                .find('.days .value').html(days).end()
                .find('.hours .value').html(hours).end()
                .find('.minutes .value').html(minutes).end();

            // Deadline has passed?
            if (t < 0) {
                clearInterval(x);
                this.element.find('.timer')
                    .find('.days .value').html('0').end()
                    .find('.hours .value').html('00').end()
                    .find('.minutes .value').html('00').end();
            }
        }, 1000);
    }

});